import {  tree_all, enableParent } from '@/api/purchase'

const enableData = []
let companyData = []
    let companylist = []
function company(){
	enableParent().then((res1) => {
		// let array = []
		res1.rows.forEach((item) => {
			enableData.push(item.deptId)
		})
		console.log(enableData,'enableData1');
	})

}
company()
async function  limitCompany() {
	// let enableData = 
	const res = await tree_all()
	// .then((res) => {
	if (res.code == 200) {
		console.log(enableData,'enableData2');
		companyData = res.data[0]
		let data = []
		for (let i = 0; i < companyData.length; i++) {
			let company = companyData[i]
			if (enableData.includes(company.deptId) && !data[i]) {
				data[i] = {
					deptId: company.deptId,
					parentId: company.parentId,
					title: company.title,
					value: company.value,
					children: [],
				}
				}
				for (let j = 0; j < company.children.length; j++) {
				let children = company.children[j]
				if (enableData.includes(children.deptId)) {
					if (!data[i]) {
					data[i] = {
						deptId: company.deptId,
						parentId: company.parentId,
						title: company.title,
						value: company.value,
						children: [],
					}
					}
					if (!data[i].children[j]) {
					data[i].children[j] = {
						deptId: children.deptId,
						parentId: children.parentId,
						title: children.title,
						value: children.value,
						children: [],
					}
					}
				}
				for (let k = 0; k < children.children.length; k++) {
					let children_k = children.children[k]
					if (enableData.includes(children.deptId)) {
					if (!data[i]) {
						data[i] = {
						deptId: company.deptId,
						parentId: company.parentId,
						title: company.title,
						value: company.value,
						children: [],
						}
					}
					if (!data[i].children[j]) {
						data[i].children[j] = {
						deptId: children.deptId,
						parentId: children.parentId,
						title: children.title,
						value: children.value,
						children: [],
						}
					}
					if (!data[i].children[j].children[k]) {
						data[i].children[j].children[k] = {
						deptId: children_k.deptId,
						parentId: children_k.parentId,
						title: children_k.title,
						value: children_k.value,
						children: [],
						}
					}
					}
				}
			}
		}
		console.log(data, 'enibledata++++++++++++++')
		companylist = data
	}
	console.log(companylist,'companylist1');

		// return companylist

	// })
	// console.log(companylist,'companylist2');

	return companylist
}
export {limitCompany}
